<template>
    <div>
        <div class="columns toolbar-box action-right">
            <div class="column is-2">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Roles</span>
                        <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-input
                            type="search"
                            v-model="filters.name"
                            placeholder="Name"
                            icon="search"
                            @change.native="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-6-tablet is-6-desktop action-box">
                <div class="field is-grouped is-grouped-right">
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="handleRoleDeletion" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                    <p class="control">
                        <router-link :to="{ name: 'roles.create' }" class="button is-info" ><span class="icon"><i
                                class="icm-new"></i></span><span>New</span></router-link>
                    </p>
                </div>
            </div>
        </div>
        <o-table
                class="fullwidth-table is-responsive is-responsive-xs-desktop"

                v-if="isTableVisible"
                :data="paginatedData"

                :bordered="table.bordered"
                :striped="table.striped"
                :narrowed="table.narrowed"
                :checkable="table.checkable"
                :mobile-cards="table.mobileCards"
                :paginated="table.paginated"
                :pagination-simple="table.paginationSimple"
                :per-page="table.perPage"
                :default-sort-direction="table.defaultSortDirection"
                :default-sort="['name', 'asc']"

                :selected.sync="selected"
                :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"

                :loading="loading"
                :total="total"
                backend-sorting
                backend-pagination
                @page-change="onPageChange"
                @sort="onSort"
        >
            <template>
                <template>
                    <o-table-column
                            v-for="col in tableColumns"
                            v-bind="col"
                            #default="{ row }"
                            :field="col.field"
                            :label="col.field == 'actions' ? '' : col.label"
                            :sortable="col.sortable"
                    >
                        <router-link v-if="col.field === 'last_editor_id'"
                                     :to="{ name: 'users.show', params: { slug: row.last_editor_id } }">
                            {{ userNameById(row.last_editor_id) }}
                        </router-link>
                        <span v-if="col.field === 'name'">
                            <router-link :to="`/roles/${row.id}`">{{ row.name }}</router-link>
                        </span>
                        <span v-if="col.field === 'description'">{{ row.description }}</span>
                        <span v-if="col.field === 'created_at'">{{ $filters.datetime(row.created_at) }}</span>
                        <span v-if="col.field === 'updated_at'">{{ $filters.datetime(row.updated_at) }}</span>

                        <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left"
                                    class="table-actions">
                          <template v-slot:trigger>
                            <button class="button">
                              <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                            </button>
                          </template>
                            <o-dropdown-item has-link>
                                <router-link :to="{ name: 'roles.show', params: { slug: row.id } }">View Role
                                </router-link>
                            </o-dropdown-item>
                        </o-dropdown>
                    </o-table-column>
                </template>
            </template>

          <template v-slot:empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>

        <div>Total: <strong>{{ total }}</strong></div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import Table from '../../mixins/Table';

    export default {
        mixins: [Table],

        data() {
            return {
                tableName: 'roles-index',
            }
        },

      computed: {
        ...mapGetters({
          itemsByIds: 'rolesByIds',
          currentRoleId: 'currentRoleId',
          userNameById: 'userNameById',
        }),

        filteredRoles() {
          return this.roles.filter((role) => {
            for (let field in this.filters) {
              let value = ''

              if (role[field]) {
                value = role[field].toLowerCase()
              }

              let filterValue = this.filters[field].toLowerCase()

              if (!value.includes(filterValue)) {
                return false
              }
            }

            return true
          })
        }
      },

      created() {
            this.filters = {
                name: '',
                email: ''
            }
        },

        mounted() {
            this.table.defaultSort = ['blocked', 'asc'];

            this.fetchPaginatedData()

            this.fetchData();
        },

        methods: {
            ...mapActions({
                fetchData: 'fetchRoles',
                removeItem: 'removeRole'
            }),

            handleRoleDeletion() {
                this.checkedRows = _.filter(this.checkedRows, row => row.id != this.currentRoleId)
                this.confirmCustomDelete()
            }
        },


    }
</script>
